import _ from 'lodash';
import {
  call,
  put,
  select,
  fork,
  takeLatest
} from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import loader from '../../../../../util/loader/loader';
import {NORMALIZE_DATA} from '../../../dataProvider/dataProvider';
import {
  LOAD_CONTENT,
  DL_PAGE_LOADED,
  SUBMIT_ORDER,
  SET_DATA,
  contractIdsSelector,
  allChargesSelector,
} from './review';
import dataProvider from '../../../../../util/dataProvider/dataProvider';
import {
  navigationRoutes,
  navigationSteps
} from '../../../navigation/navigationHelpers';
import {
  showGlobalSpinner,
  hideGlobalSpinner,
  errorPageByFlow
} from '../../../common/common';
import {
  setQuickCheckoutData
} from '../../../data/quickCheckout/quickCheckout';

// WATCHERS
export function* loadContentWatch() {
  yield takeLatest(LOAD_CONTENT, loadContentWorker);
}

export function* normalizeWatch() {
  yield takeLatest(NORMALIZE_DATA, normalizeWorker);
}

export function* submitOrderWatch() {
  yield takeLatest(SUBMIT_ORDER, submitOrderWorker);
}

// WORKERS
export function* loadContentWorker() {
  try {
    yield put(showGlobalSpinner({hideContent: true, initiator: 'localize load'}));
    const errorPage = yield select(errorPageByFlow);

    const success = yield call(dataProvider.load, [
      {state: 'auth'},
      {state: 'customer'},
      {state: 'context'},
      {state: 'plan'},
      {state: 'reviewPlanCart'},
      {state: 'quickCheckoutAnalytics'}
    ], {errorPage});

    if (!success) {
      return;
    }

    yield put({
      type: DL_PAGE_LOADED
    });

    yield put(hideGlobalSpinner());

  } catch(e) {
    yield put(hideGlobalSpinner());
    browserHistory.push(navigationRoutes[navigationSteps.quickCheckout.ERROR].path);
  }
}

export function* normalizeWorker({key, data, meta}) {
  if (key !== 'reviewPlanCart' && key !== 'submitOrder') {
    return;
  }

  yield put({
    type: SET_DATA,
    payload: {
      ...meta,
      content: {
        review: {
          ...data.review,
          flowType: data.flowType
        },
        consentCart: data.consentCart
      }
    }
  });

  //console.log(data.review);

  // NOTE: this approach only works if there's only one item being added.
  // It will need to be updated to support adding multiple items.
  const allCharges = yield select(allChargesSelector);
  const filteredCharges = _.filter(allCharges, item => !_.isEmpty(item));
  const productData = !_.isEmpty(filteredCharges) ? _.head(filteredCharges)[0] : false;

  if (productData) {
    yield put(setQuickCheckoutData({
      productId: productData.id,
      productName: productData.name
    }));
  }
}

export function* submitOrderWorker() {
  try {
    const errorPage = yield select(errorPageByFlow);
    const contractIds = yield select(contractIdsSelector);

    const data = {
      acceptedContractIds : contractIds,
      isVerified: true,
    };

    const endpoint = navigationRoutes[navigationSteps.myPlan.REVIEW].endpoints.submitOrder();
    const success = yield call(loader.request, endpoint, {data, hideContentWhileLoading: false, errorPage});

    if (!success) {
      return;
    }

  } catch(e) {
    //console.log(e)
  }
}

export default function* myplanReviewSagas() {
  yield [
    fork(loadContentWatch),
    fork(normalizeWatch),
    fork(submitOrderWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/MyPlan/review/reviewSagas.js
 **/